import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const QuestionCategory = ({ category, questions, icon, color }) => {
  const [expanded, setExpanded] = useState(true);
  const [copied, setCopied] = useState(null);

  const handleCopy = (q, i) => {
    navigator.clipboard?.writeText(q)?.catch(() => {});
    setCopied(i);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <button onClick={() => setExpanded(!expanded)} className="w-full flex items-center justify-between p-4 md:p-5 hover:bg-muted/30 transition-colors">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: `${color}20` }}>
            <Icon name={icon} size={18} color={color} />
          </div>
          <span className="font-semibold text-foreground">{category}</span>
          <span className="px-2 py-0.5 rounded-full text-xs" style={{ background: `${color}15`, color }}>{questions?.length} questions</span>
        </div>
        <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size={18} color="#888" />
      </button>
      {expanded && (
        <div className="px-4 pb-4 space-y-2">
          {questions?.map((q, i) => (
            <div key={i} className="flex items-start gap-3 p-3 rounded-lg bg-muted/20 hover:bg-muted/40 transition-colors group">
              <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: `${color}20` }}>
                <span className="text-xs font-bold" style={{ color }}>{i + 1}</span>
              </div>
              <p className="flex-1 text-sm text-foreground leading-relaxed">{q}</p>
              <button onClick={() => handleCopy(q, i)} className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded" title="Copy question">
                <Icon name={copied === i ? 'Check' : 'Copy'} size={14} color={copied === i ? '#00FF88' : '#888'} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuestionCategory;
